module.exports = __webpack_public_path__ + "img/1534356317.f98e93b2.jpg";